'use strict';

angular.module('openDataApp')
  .factory('ContentProvider', function () {
    return {
      main: {
        title: 'OpenData',
        intro: 'Eén API om gegevens te integreren, valideren en verrijken in online formulieren',
        pageTitle: 'OpenData',
        color: { x: ['#333333', '#67C2C0', '#254FA4'], y: ['#ffffff', '#2FA8C5', '#000000'] },
        showcase: 'main',
        subdomain: 'opendata'
      },
      dashboard: {
        title: 'Dashboard',
        pageTitle: 'Dashboard &laquo; OpenData',
        color: { x: ['#607D8B', '#37474F', '#000000'], y: ['#000000', '#37474F', '#000000'] }
      },
      iban: {
        key: 'iban',
        title: 'OpenIBAN',
        pageTitle: 'Zet je rekeningnummer om naar IBAN met OpenIBAN.nl',
        intro: 'Met deze webservice kun je gratis en snel je bankrekeningnummer omrekenen naar een IBAN. Een BIC of banknaam is niet nodig',
        keywords: 'iban,openiban,omrekenen,berekenen,tool,rekeningnummer,api,opendata,data',
        short: 'OpenIBAN',
        icon: 'payment',
        subdomain: 'openiban',
        color: { x: ['#00C18F', '#00746D', '#000000'], y: ['#aaaaaa', '#00746D', '#000000'] },
        summary: 'views/iban/summary.html'
      },
      kvk: {
        key: 'kvk',
        title: 'OpenKVK',
        pageTitle: 'OpenKVK &bull; OpenData',
        intro: 'Eén API om bedrijfsgegevens te integreren, valideren en verrijken in online formulieren',
        short: 'OpenKVK',
        icon: 'work',
        subdomain: 'openkvk',
        controller: 'OpenKvkCtrl',
        color: { x: ['#75D9FF', '#005989', '#000000'], y: ['#000000', '#005989', '#000000'] },
        summary: 'views/kvk/summary.html'
      },
      postal: {
        key: 'postal',
        title: 'OpenPostcode',
        pageTitle: 'OpenPostcode &bull; OpenData',
        intro: 'Eén API om gegevens te integreren, valideren en verrijken in online formulieren',
        short: 'OpenPostcode',
        icon: 'home',
        subdomain: 'openpostcode',
        controller: 'OpenPostalCtrl',
        color: { x: ['#C86B3A', '#684768', '#000000'], y: ['#000000', '#684768', '#000000'] },
        summary: 'views/postal/summary.html'
      },
      services: ['postal', 'iban', 'kvk']
    };
  });
